import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { useSelector } from 'react-redux';
import { LoadingOutlined } from '@ant-design/icons';
import { ApplicationState } from '../../../../../../../../../store';
import mask from '../../../../../../../../../utils/mask';
import { ListarMotoristaOrdemDeColetaServices } from '../../services/editarOrdemDeColetaServices';

interface Props {
  setSelectedMotorista: React.Dispatch<React.SetStateAction<number>>;
  nomeMotorista: string;
}

export interface IMotorista {
  nome: string;
  cpf: string;
  mopp: boolean;
  habilitado: string;
  codMotorista?: number;
}

const SelectMotorista: React.FC<Props> = ({ setSelectedMotorista, nomeMotorista }) => {
  const { Option } = Select;
  const loading = useSelector((state: ApplicationState) => state.Motorista.loading);
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const [motorista, setMotorista] = useState<IMotorista[]>([]);

  useEffect(() => {
    ListarMotoristaOrdemDeColetaServices.getMotoristaPortal(inscricaoAtiva).then((res) => {
      setMotorista(res.data?.motoristas);
    });
  }, [inscricaoAtiva]);

  const handleSelect = (_value: string, e: any) => {
    setSelectedMotorista(+e.key);
  };

  return (
    <>
      {!loading ? (
        <Select
          style={{ width: '100%', textAlign: 'center' }}
          filterOption={(inputValue, element) => {
            return element?.value
              .toString()
              .toLowerCase()
              .replace(/\.|-/g, '')
              .includes(inputValue.replace(/\.|-/g, '').toLowerCase());
          }}
          showSearch
          onChange={handleSelect}
          placeholder={mask('camelCase', nomeMotorista)}
        >
          {motorista.map((item: IMotorista) => (
            <Option
              title={item.nome}
              className="optionselect"
              value={item.nome}
              key={item.codMotorista}
            >
              <p>
                {mask('camelCase', item.nome)}
                <br />
                {mask('cpfCnpj', item.cpf)}
                <hr />
              </p>
            </Option>
          ))}
        </Select>
      ) : (
        <LoadingOutlined />
      )}
    </>
  );
};

export default SelectMotorista;
